import $ from 'jquery';
import get from 'lodash/get';
import removeQueryParam from "../../helpers/remove-query-param";

export default function(){
    const newsletter = get(window, 'rcProps.trigger.global.subscribeToNewsletter', false);
    if (newsletter && window.rcProps.doNotAutoSubscribeToNewsletter === undefined) {
        var email = window.rcProps.trigger.global.subscribeToNewsletter;
        $('#email_signup_form--input').val(email);
        setTimeout(function() {
            $('.site-sign-up__button').trigger('click');
        });
        removeQueryParam('userEmail');
    }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/amp-newsletter.js